// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from 'D:/ZRTC/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/~demos/:uuid",
    "layout": false,
    "wrappers": [require('../dumi/layout').default],
    "component": ((props) => {
        const React = require('react');
        const { default: getDemoRenderArgs } = require('D:/ZRTC/node_modules/@umijs/preset-dumi/lib/plugins/features/demo/getDemoRenderArgs');
        const { default: Previewer } = require('dumi-theme-default/es/builtins/Previewer.js');
        const { usePrefersColor, context } = require('dumi/theme');

        
      const { demos } = React.useContext(context);
      const [renderArgs, setRenderArgs] = React.useState([]);

      // update render args when props changed
      React.useLayoutEffect(() => {
        setRenderArgs(getDemoRenderArgs(props, demos));
      }, [props.match.params.uuid, props.location.query.wrapper, props.location.query.capture]);

      // for listen prefers-color-schema media change in demo single route
      usePrefersColor();

      switch (renderArgs.length) {
        case 1:
          // render demo directly
          return renderArgs[0];

        case 2:
          // render demo with previewer
          return React.createElement(
            Previewer,
            renderArgs[0],
            renderArgs[1],
          );

        default:
          return `Demo ${props.match.params.uuid} not found :(`;
      }
    
        })
  },
  {
    "path": "/_demos/:uuid",
    "redirect": "/~demos/:uuid"
  },
  {
    "__dumiRoot": true,
    "layout": false,
    "path": "/",
    "wrappers": [require('../dumi/layout').default, require('D:/ZRTC/node_modules/@umijs/preset-dumi/node_modules/dumi-theme-default/es/layout.js').default],
    "routes": [
      {
        "path": "/",
        "component": require('D:/ZRTC/docs/index.md').default,
        "exact": true,
        "meta": {
          "filePath": "docs/index.md",
          "updatedTime": 1720466783243,
          "gapless": true,
          "slugs": [],
          "title": "Index"
        },
        "title": "Index - ZRTC"
      },
      {
        "path": "/home/documentation",
        "component": require('D:/ZRTC/docs/Home/documentation.md').default,
        "exact": true,
        "meta": {
          "filePath": "docs/Home/documentation.md",
          "updatedTime": 1720424606000,
          "slugs": [
            {
              "depth": 1,
              "value": "如何使用：",
              "heading": "如何使用"
            }
          ],
          "title": "如何使用：",
          "nav": {
            "path": "/home",
            "title": "Home"
          }
        },
        "title": "如何使用： - ZRTC"
      },
      {
        "path": "/home",
        "meta": {},
        "exact": true,
        "redirect": "/home/documentation"
      }
    ],
    "title": "ZRTC",
    "component": (props) => props.children
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
